import {configureStore} from '@reduxjs/toolkit';
import memberReducer from './reducers/memberSlice';
import settingsReducer from './reducers/settingsSlice';

export default function createStore() {
    return configureStore({
        reducer: {
            member: memberReducer,
            settings: settingsReducer,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [],
                    ignoredPaths: [],
                },
            }),
        devTools: process.env.NODE_ENV !== 'production',
    });
}
